import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=8a5403ac&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "page-not-found.vue"
export default component.exports